import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/activities',
  routes: [
    {
      path: '/vipfree',
      name: 'vipfree',
      component: resolve => require(['@/components/pages/vip7day/vipfree.vue'], resolve),
      meta: {
        title: '免费领取7天超级会员'
      },
    },
    {
      path: '/result',
      name: 'result',
      component: resolve => require(['@/components/pages/vip7day/result.vue'], resolve),
      meta: {
        title: '领取成功'
      },
    },
    {//人人必学的家庭健康课
      path: '/pingan',
      name: 'pingan',
      component: resolve => require(['@/components/pages/pingan/index.vue'], resolve),
      meta: {
        title: '免费领取课程'
      },
    },
    {//人人必学的家庭健康课
      path: '/pinganResult',
      name: 'result_pingan',
      component: resolve => require(['@/components/pages/pingan/result.vue'], resolve),
      meta: {
        title: '领取成功'
      },
    },
    { //活动名称：中国农业银行用户送会员年卡
      path: '/abc',
      name: 'AgriculturalBank',
        component: resolve => require(['@/components/pages/AgriculturalBank/intr.vue'], resolve),
        meta: {
          title: '吴晓波频道联名卡—首刷礼领取'
        },
    },
    { //活动名称：中国农业银行用户送会员年卡
      path: '/abcReceive',
      name: 'AgriculturalBank',
        component: resolve => require(['@/components/pages/AgriculturalBank/index.vue'], resolve),
        meta: {
          title: '吴晓波频道联名卡—首刷礼领取'
        },
    },
    { //活动名称：中国农业银行用户送会员年卡
      path: '/abcGift',
      name: 'AgriculturalBank',
        component: resolve => require(['@/components/pages/AgriculturalBank/gift.vue'], resolve),
        meta: {
          title: '吴晓波频道联名卡—首刷礼领取'
        },
    },
    { //活动名称：中国农业银行用户送会员年卡
      path: '/abcResult',
      name: 'AgriculturalBankResults',
        component: resolve => require(['@/components/pages/AgriculturalBank/result.vue'], resolve),
        meta: {
          title: '领取成功—吴晓波频道联名卡—首刷礼领取'
        },
    },
    // 广东移动免费领取七天超级会员
    {
      path: '/vipfreeYd',
      name: 'vipfree',
      component: resolve => require(['@/components/pages/vip_yidong/vipfree.vue'], resolve),
      meta: {
        title: '免费领取7天超级会员'
      },
    },
    {
      path: '/resultYd',
      name: 'result',
      component: resolve => require(['@/components/pages/vip_yidong/result.vue'], resolve),
      meta: {
        title: '领取成功'
      },
    },
    {
      path: '/invite',
      name: 'invite',
      component: resolve => require(['@/components/pages/invite/index.vue'], resolve),
      meta: {
        title: '邀好友全场免费听'
      },
    },
    {
      path: '/wxb',
      name: 'wxb',
      component: resolve => require(['@/components/pages/wxb/index.vue'], resolve),
      meta: {
        title: '免费领—吴晓波精品课'
      },
    },
    {
      path: '/epidemic',
      name: 'epidemic',
      component: resolve => require(['@/components/pages/epidemic/index.vue'], resolve),
      meta: {
        title: '890新商学疫情特别策划'
      },
    },
    {
      path: '/epidemicResult',
      name: 'epidemicResult',
      component: resolve => require(['@/components/pages/epidemic/epidemicResult.vue'], resolve),
      meta: {
        title: '890新商学疫情特别策划'
      },
    },
    {
      path: '/indomitable',
      name: 'indomitable',
      component: resolve => require(['@/components/pages/indomitable/index.vue'], resolve),
      meta: {
        title: '免费领加油2020知识包'
      },
    },
    {
      path: '/growthGuide',
      name: 'growthGuide',
      component: resolve => require(['@/components/pages/growthGuide/index.vue'], resolve),
      meta: {
        title: '免费领中小企业成长指南'
      },
    },
    {
      path: '/lachTemplate',
      name: 'lachTemplate',
      component: resolve => require(['@/components/pages/lachineTemp/index.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/lachTemplateRecevice',
      name: 'lachTemplateRecevice',
      component: resolve => require(['@/components/pages/lachineTemp/recevice.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/lachTemplateAddress',
      name: 'lachTemplateAddress',
      component: resolve => require(['@/components/pages/lachineTemp/address.vue'], resolve),
      meta: {
        title: '填写信息'
      },
    },
    {
      path: '/lachTemplateResult',
      name: 'lachTemplateResult',
      component: resolve => require(['@/components/pages/lachineTemp/result.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/lachTemplateInfo',
      name: 'lachTemplateInfo',
      component: resolve => require(['@/components/pages/lachineTemp/info.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/lachTemplateNotice',
      name: 'lachTemplateNotice',
      component: resolve => require(['@/components/pages/lachineTemp/notice.vue'], resolve),
      meta: {
        title: '提示'
      },
    },
    {
      path: '/automation',
      name: 'automation',
      component: resolve => require(['@/components/pages/automationH5/index.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/automationResult',
      name: 'automationResult',
      component: resolve => require(['@/components/pages/automationH5/result.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/attraction',
      name: 'attraction',
      component: resolve => require(['@/components/pages/attraction/index.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/promotion',
      name: 'promotion',
      component: resolve => require(['@/components/pages/promotion/index.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/growingDay',
      name: 'growingDay',
      component: resolve => require(['@/components/pages/growingDay/index.vue'], resolve),
      meta: {
        title: '年卡会员买1年送1年'
      },
    },
    {
      path: '/growingDayResult',
      name: 'growingDayResult',
      component: resolve => require(['@/components/pages/growingDay/result.vue'], resolve),
      meta: {
        title: '订阅成功'
      },
    },
    {
      path: '/ablink',
      name: 'ablink',
      component: resolve => require(['@/components/pages/ablink/index.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: resolve => require(['@/components/pages/coupon/index.vue'], resolve),
      meta: {
        title: ''
      },
    },
    {
      path: '/camp',
      name: 'camp',
      component: resolve => require(['@/components/pages/trainingCamp/index.vue'], resolve),
      meta: {
        title: '学习特训营'
      },
    },
    {
      path: '/campResult',
      name: 'campResult',
      component: resolve => require(['@/components/pages/trainingCamp/result.vue'], resolve),
      meta: {
        title: '添加小助理'
      },
    },
    {
      path: '/welfare',
      name: 'welfare',
      component: resolve => require(['@/components/pages/welfare/index.vue'], resolve),
      meta: {
        title: '免费领粉丝专属福利《直男小课堂》'
      },
    },
    {
      path: '/advertisement',
      name: 'advertisement',
      component: resolve => require(['@/components/pages/advertisement/index.vue'], resolve),
      meta: {
        title: '吴晓波频道投资第一课'
      },
    },
    {
      path: '/advertisementResult',
      name: 'advertisementResult',
      component: resolve => require(['@/components/pages/advertisement/result.vue'], resolve),
      meta: {
        title: '添加总编助理'
      },
    },

    //新每天听见
    {
      path: '/lachine',
      name: 'lachine',
      component: resolve => require(['@/components/pages/lachine/index.vue'], resolve),
      meta: {
        title: '限时福利'
      },
    },
    {
      path: '/lachineRecevice',
      name: 'lachineRecevice',
      component: resolve => require(['@/components/pages/lachine/recevice.vue'], resolve),
      meta: {
        title: '好友送你一张「亲友卡」'
      },
    },
    {
      path: '/lachineResult',
      name: 'lachineResult',
      component: resolve => require(['@/components/pages/lachine/result.vue'], resolve),
      meta: {
        title: '领取成功'
      },
    },
    {
      path: '/lachineNotice',
      name: 'lachineNotice',
      component: resolve => require(['@/components/pages/lachine/notice.vue'], resolve),
      meta: {
        title: '《每天听见吴晓波》限时福利'
      },
    },

    //新每天听见7人
    {
      path: '/lachine7',
      name: 'lachine7',
      component: resolve => require(['@/components/pages/lachine7/index.vue'], resolve),
      meta: {
        title: '限时福利'
      },
    },
    {
      path: '/lachine7Recevice',
      name: 'lachine7Recevice',
      component: resolve => require(['@/components/pages/lachine7/recevice.vue'], resolve),
      meta: {
        title: '好友送你一张亲友卡'
      },
    },
    {
      path: '/lachine7Result',
      name: 'lachine7Result',
      component: resolve => require(['@/components/pages/lachine7/result.vue'], resolve),
      meta: {
        title: '领取成功'
      },
    },
    {
      path: '/lachine7Notice',
      name: 'lachine7Notice',
      component: resolve => require(['@/components/pages/lachine7/notice.vue'], resolve),
      meta: {
        title: '提示'
      },
    },

    //新每天听见
    {
      path: '/spread',
      name: 'spread',
      component: resolve => require(['@/components/pages/spread/index.vue'], resolve),
      meta: {
        title: '邀好友得4重好礼'
      },
    },
    {
      path: '/spreadRecevice',
      name: 'spreadRecevice',
      component: resolve => require(['@/components/pages/spread/recevice.vue'], resolve),
      meta: {
        title: '7天会员免费领'
      },
    },
    {
      path: '/spreadList',
      name: 'spreadList',
      component: resolve => require(['@/components/pages/spread/list.vue'], resolve),
      meta: {
        title: '领取记录'
      },
    },
    {
      path: '/newSpread',
      name: 'newSpread',
      component: resolve => require(['@/components/pages/newSpread/index.vue'], resolve),
      meta: {
        title: '邀好友得4重好礼'
      },
    },
    {
      path: '/newSpreadRecevice',
      name: 'newSpreadRecevice',
      component: resolve => require(['@/components/pages/newSpread/recevice.vue'], resolve),
      meta: {
        title: '7天会员免费领'
      },
    },
    {
      path: '/newSpreadResult',
      name: 'newSpreadResult',
      component: resolve => require(['@/components/pages/newSpread/result.vue'], resolve),
      meta: {
        title: '领取记录'
      },
    },
    {
      path: '/flashSale',
      name: 'flashSale',
      component: resolve => require(['@/components/pages/secKilling/index.vue'], resolve),
      meta: {
        title: '一元听好课'
      },
    },
    {
      path: '/bargain',
      name: 'bargain',
      component: resolve => require(['@/components/pages/secKilling/bargain.vue'], resolve),
      meta: {
        title: '一元听好课'
      },
    },
    {
      path: '/bargainDetail',
      name: 'bargainDetail',
      component: resolve => require(['@/components/pages/secKilling/detail.vue'], resolve),
      meta: {
        title: '课程详情'
      },
    },
    {
      path: '/anniversary',
      name: 'anniversary',
      component: resolve => require(['@/components/pages/anniversary/index.vue'], resolve),
      meta: {
        title: '超级会员立减800元'
      },
    },
    {
      path: '/anniversaryResult',
      name: 'anniversaryResult',
      component: resolve => require(['@/components/pages/anniversary/result.vue'], resolve),
      meta: {
        title: '购买成功'
      },
    },
    {
      path: '/anniversaryPay',
      name: 'anniversaryPay',
      component: resolve => require(['@/components/pages/anniversary/alipay.vue'], resolve),
      meta: {
        title: '立即购买'
      },
    },
    {
      path: '/union-yintai99',
      name: 'union-yintai99',
      component: resolve => require(['@/components/pages/union/index99.vue'], resolve),
      meta: {
        title: '成都银泰中心in99 x 吴晓波频道'
      },
    },
    {
      path: '/union-pd-yintai99',
      name: 'union-pd-yintai99',
      component: resolve => require(['@/components/pages/union/index-pd99.vue'], resolve),
      meta: {
        title: '吴晓波频道 x 成都银泰中心in99'
      },
    },

    {
      path: '/a202375-choose',
      name: 'promoterChoose',
      component: resolve => require(['@/components/pages/a202375/choose.vue'], resolve),
      meta: {
        title: '买1年送1年'
      },
    },
    {
      path: '/a202375-joinNow',
      name: 'promoterJoinNow',
      component: resolve => require(['@/components/pages/a202375/joinNow.vue'], resolve),
      meta: {
        title: '买1年送1年'
      },
    },
    {
      path: '/a202375-recevice',
      name: 'promoterRecevice',
      component: resolve => require(['@/components/pages/a202375/recevice.vue'], resolve),
      meta: {
        title: '好友专属赠礼'
      },
    },
    {
      path: '/a202375-result',
      name: 'promoterResult',
      component: resolve => require(['@/components/pages/a202375/result.vue'], resolve),
      meta: {
        title: '好友专属赠礼'
      },
    },
    {
      path: '/a202375-resultApp',
      name: 'promoterResultApp',
      component: resolve => require(['@/components/pages/a202375/resultApp.vue'], resolve),
      meta: {
        title: '买1年送1年'
      },
    },
    {
      path: '/a202375-resultFail',
      name: 'promoterResultFail',
      component: resolve => require(['@/components/pages/a202375/resultFail.vue'], resolve),
      meta: {
        title: '好友专属赠礼'
      },
    },
     //2025 58活动
    {
      path: '/a202558',
      name: 'a202558',
      component: resolve => require(['@/components/pages/a202558/index.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-report',
      name: 'a202558-report',
      component: resolve => require(['@/components/pages/a202558/report.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-test',
      name: 'a202558-test',
      component: resolve => require(['@/components/pages/a202558/components/Poster.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-home',
      name: 'a202558-home',
      component: resolve => require(['@/components/pages/a202558/home.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-1',
      name: 'a202558-1',
      component: resolve => require(['@/components/pages/a202558/components/page1.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-2',
      name: 'a202558-2',
      component: resolve => require(['@/components/pages/a202558/components/page2.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-3',
      name: 'a202558-3',
      component: resolve => require(['@/components/pages/a202558/components/page3.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-4',
      name: 'a202558-4',
      component: resolve => require(['@/components/pages/a202558/components/page4.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-5',
      name: 'a202558-5',
      component: resolve => require(['@/components/pages/a202558/components/page5.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-6',
      name: 'a202558-6',
      component: resolve => require(['@/components/pages/a202558/components/page6.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-7',
      name: 'a202558-7',
      component: resolve => require(['@/components/pages/a202558/components/page7.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-8',
      name: 'a202558-8',
      component: resolve => require(['@/components/pages/a202558/components/page8.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
    {
      path: '/a202558-9',
      name: 'a202558-9',
      component: resolve => require(['@/components/pages/a202558/components/page9.vue'], resolve),
      meta: {
        title: '学习报告'
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js